import { MomentDateAdapter } from "@angular/material-moment-adapter";

export class CustomDateAdapter extends MomentDateAdapter {

  override getDayOfWeekNames(style: 'long' | 'short' | 'narrow') {
    return [
      'الأحد',
      'الإثنين',
      'الثلاثاء',
      'الأربعاء',
      'الخميس',
      'الجمعة',
      'السبت',
    ];
  }
}
